import React from 'react';
import { Availability } from './types';
import { Localizer } from 'services/Localizer';

interface ProductAvailabilityProps {
	availability?: Availability | null;
}

/**
 * Custom, HCL product availability display
 */
export default function ProductAvailabilityHCL(props: ProductAvailabilityProps) {
	const { availability } = props;

	let status = '';
	if (!availability) {
		status = Localizer('Call') + ' 1-800-848-1633';
	} else if (availability.backOrder) {
		status = Localizer('Backordered');
	} else if (availability.outOfStock) {
		status = Localizer('OutOfStock');
	} else if (availability.callForAvailability) {
		status = Localizer('Call') + ' 1-800-848-1633';
	} else {
		status = Localizer('InStock');
	}

	return (
		<p className="roc-pdp-main-info__label-text">
			{Localizer('StockStatus')}: &nbsp;
			<span>{status}</span>
		</p>
	);
}
